import {ClientUserState} from '../../../../../shared/scripts/ClientUserState'
import {UIMHeaderHamburgerController} from './UIMHeaderHamburgerController'
import {UIMHeaderProfileController} from './UIMHeaderProfileController'
import {setElementInnerHTML, setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {ViewPopupEditProfile} from '../../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {UIMProfileUsernameController} from '../body/UIMProfileUsernameController'
import {UIHeaderController} from '../../../../../shared/scripts/ui_html/header/UIHeaderController'
import {uiManager} from '../../../EntryMobile'

export class UIMHeaderController extends UIHeaderController {
    private readonly headerContainer: HTMLDivElement
    readonly profileController: UIMHeaderProfileController
    readonly hamburgerController: UIMHeaderHamburgerController

    constructor() {
        super()
        this.headerContainer = document.getElementById('header-container') as HTMLDivElement
        this.profileController = new UIMHeaderProfileController()
        this.hamburgerController = new UIMHeaderHamburgerController()

        ClientUserState.registerChangeListener(() => {
            this.updateHeaderData()
        })
    }

    hide() {
        this.headerContainer.style.display = 'none'
        this.hamburgerController.hide()
    }

    show() {
        this.headerContainer.style.display = 'flex'
        this.hamburgerController.show()
    }

    private updateHeaderData() {
        if(ClientUserState.userState == undefined) return
        const userNameElement = document.getElementById('header-element-profile-name') as HTMLDivElement
        const karmaElement = document.getElementById('header-element-profile-karma') as HTMLDivElement

        userNameElement.innerText = ClientUserState.userState.username
        setElementOnClick(userNameElement, () => UIMHeaderController.openEditProfilePopup())
        setElementInnerHTML(karmaElement, ClientUserState.userState.getPlayerKarmaStatusText())
        this.profileController.updateMembershipIcon(ClientUserState.userState)

        const iconElement = document.getElementById('header-element-profile-avatar') as HTMLImageElement

        UIMHeaderProfileController.updateIcon(ClientUserState.userState.icon, iconElement)

        setElementOnClick(iconElement, () => UIMHeaderController.openEditProfilePopup())
    }

    private static openEditProfilePopup() {
        new ViewPopupEditProfile({
            usernameController: UIMProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
        })
    }

    protected setupShuffleLinkInterceptor() {
        const notificationPanelContent = this.notificationPanelController.notificationPanelContent

        const setupLinks = () => {
            const shuffleLinks = notificationPanelContent.querySelectorAll('a[href*="#matchmakingqueue=16"]') as NodeListOf<HTMLLinkElement>

            shuffleLinks.forEach((link) => {
                if(link.hasAttribute('data-shuffle-handler')) return
                link.setAttribute('data-shuffle-handler', 'true')

                link.removeAttribute('href')

                setElementOnClick(link, () => {
                    this.notificationPanelController?.hideNotificationPanel()
                    uiManager.goToMainPageAndSelectShuffle()
                    UIMHeaderController.sendPlayNowClickAnalytic()
                }, true)
            })
        }

        setupLinks()
        setTimeout(() => setupLinks(), 1000)
    }
}
